import SEOHead from "@/components/SEOHead";
import OnlineQuoteBuilder from "@/components/OnlineQuoteBuilder";
import TrustBar from "@/components/TrustBar";
import RelatedTools from "@/components/RelatedTools";
import SolutionsCrossSell from "@/components/SolutionsCrossSell";
import { CheckCircle } from "lucide-react";

export default function OnlineQuotePage() {
  return (
    <div>
      <SEOHead title="Online Payment Estimate" description="Get an instant estimate for online card processing. See your likely monthly gateway and processing costs in seconds." path="/quote/online" />

      <section className="py-10 md:py-16 bg-gray-50" id="quote" data-testid="quote-section">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-6">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-aqua mb-2">Instant Estimate</p>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-brand-black tracking-tight mb-3">See what online payments could cost</h1>
            <p className="text-brand-grey leading-relaxed max-w-xl mx-auto">Enter your online processing profile and get an instant indicative estimate. No obligation, no sign-up.</p>
          </div>
          <OnlineQuoteBuilder />
        </div>
      </section>

      <TrustBar />

      <section className="py-14 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-2xl font-bold text-brand-black mb-6">Built for online businesses</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left max-w-lg mx-auto">
            {["WooCommerce, Shopify, Magento — plug-and-play", "PCI DSS compliant, 3-D Secure 2.x as standard", "Clear docs, sandbox access, dedicated support", "Fast integration with your existing platform"].map((item) => (
              <div key={item} className="flex items-start gap-2 text-sm text-brand-black"><CheckCircle size={16} className="text-brand-aqua flex-shrink-0 mt-0.5" />{item}</div>
            ))}
          </div>
        </div>
      </section>

      <RelatedTools currentPath="/quote/online" />
      <SolutionsCrossSell currentPath="/quote/online" />
    </div>
  );
}
